import { AUTH_COOKIE, LOCAL_STORAGE, SESSION_KEYS, USER_COOKIE, } from '../utils.constant';
import { isServer } from '../../utils/browser';
import Cookies from 'js-cookie';
import { Analytics } from '../analytics';
import { AnalyticsType } from '../../types/Analytics';
function removeAllCookies() {
    const authToken = Cookies.get(AUTH_COOKIE.AUTH_TOKEN);
    if (authToken) {
        Cookies.remove(AUTH_COOKIE.AUTH_TOKEN, {
            path: '/',
            secure: true,
            sameSite: 'strict',
        });
    }
    Object.keys(Cookies.get()).forEach(function (cookieName) {
        Cookies.remove(cookieName);
    });
}
export function getAuthToken() {
    if (isServer()) {
        return;
    }
    return localStorage.getItem('authToken');
}
export const logout = (redirectionURL = '/') => {
    Analytics.reset(AnalyticsType.RUDDER_STACK, true);
    window.localStorage.clear();
    window.sessionStorage.clear();
    removeAllCookies();
    const data = {
        loggedin: false,
    };
    Cookies.set(window.btoa(USER_COOKIE.USER_DATA), JSON.stringify(data), {
        domain: 'invideo.io',
    });
    Cookies.set(window.btoa(USER_COOKIE.USER_DETAILS), JSON.stringify(data), {
        domain: 'invideo.io',
    });
    Cookies.set(window.btoa(USER_COOKIE.COUPON), '', { domain: 'invideo.io' });
    setTimeout(() => {
        window.location.href = redirectionURL;
    }, 500);
};
export const isValidTeamInviteAction = (action) => {
    return action && decodeURIComponent(action) === window.btoa('team-invite');
};
export function setStorageData(response, data, setLocalStorage) {
    if (data.token) {
        const halfYear = new Date(new Date().getTime() + 86400 * 182 * 1000);
        localStorage.setItem(LOCAL_STORAGE.AUTH_TOKEN, data.token);
        Cookies.set(AUTH_COOKIE.AUTH_TOKEN, data.token, {
            expires: halfYear,
            path: '/',
            secure: true,
            sameSite: 'strict',
        });
        if (data.token_expires) {
            localStorage.setItem(LOCAL_STORAGE.AUTH_EXPIRES, data.token_expires?.toString());
        }
    }
    if (setLocalStorage) {
        localStorage.setItem(LOCAL_STORAGE.ACCOUNT_DETAILS, JSON.stringify(response.account_details));
        localStorage.setItem(window.btoa(LOCAL_STORAGE.USER), JSON.stringify(response));
    }
    if (data.new_user) {
        sessionStorage.setItem(SESSION_KEYS.NEW_USER, data.new_user?.toString());
    }
}
function isUserBucketEligible(userBucket, userCreatedAt, experimentJsonNew) {
    if (experimentJsonNew &&
        Object.keys(experimentJsonNew).length &&
        Object.keys(experimentJsonNew).includes(userBucket))
        return (new Date(experimentJsonNew[userBucket]) < new Date(userCreatedAt * 1000));
    return true;
}
export function isUserEligibleForReactFrontend(user, config) {
    const experimentJson = config?.['iv-fe-react'];
    if (!experimentJson || (experimentJson && !experimentJson.status)) {
        return false;
    }
    const { buckets, new: experimentJsonNew, blacklist_accounts, whitelisted_accounts, whitelisted_email_domains, status, } = experimentJson;
    if (!status) {
        return false;
    }
    const { bucket, created_at, account, email } = user;
    const userBucket = bucket?.toUpperCase();
    const releasedBuckets = buckets?.map(bucket => bucket.toUpperCase());
    if (blacklist_accounts && account && blacklist_accounts.includes(account))
        return false;
    if (whitelisted_accounts && account && whitelisted_accounts.includes(account))
        return true;
    if (whitelisted_email_domains &&
        email &&
        whitelisted_email_domains.includes(email.split('@')[1])) {
        return true;
    }
    return (!!userBucket &&
        !!created_at &&
        !!account &&
        !!releasedBuckets &&
        !!Object.keys(experimentJson).length &&
        releasedBuckets.includes(userBucket) &&
        isUserBucketEligible(bucket, created_at, experimentJsonNew));
}
export function setReactFrontendCookie() {
    Cookies.set('feApp', 'react', {
        path: '/',
        secure: true,
        expires: 365,
    });
}
export const getNumberOfDaysSinceSignup = (userData) => {
    const currentTimestampInMs = Date.now();
    const accountData = userData;
    if (!accountData) {
        return 0;
    }
    const signupTimestampInMs = (accountData['created_at'] || 0) * 1000;
    const diffInMs = currentTimestampInMs - signupTimestampInMs;
    const diffInDays = Math.floor(diffInMs / 1000 / 60 / 60 / 24);
    return diffInDays;
};
